import { where } from 'firebase/firestore'
import FirestoreService from '../../firestoreService'
import { chunk } from 'lodash'

import { getConvertedData } from '../../../models/interface.helper'

import { HorseCompetitonPaperworkModel } from '../../../models/horse-competiton-paperwork/horse-competiton-paperwork.model'
import { IHorseCompetitorDocument } from '../../../models/horse-competiton-paperwork/horse-competiton-paperwork-interface'

import { CONST } from '../../../const/const'

const COLLECTIONS = CONST.DATA.FIRESTORE.V01.COLLECTIONS

export const getById = async (id: string) => {
  const horseCompetitionPaperworkSnapShot = await FirestoreService.getItem(
    COLLECTIONS.HORSE_COMPETITION_PAPERWORK.NAME,
    id
  )
  return getConvertedData(
    HorseCompetitonPaperworkModel.fromFirestoreDoc(horseCompetitionPaperworkSnapShot).toObject()
  )
}

export const getByHorseIds = async (ids: string[]) => {
  const horsesCompetitionPaperwork: IHorseCompetitorDocument[] = []

  if (ids?.[0]) {
    const chunks = chunk(ids, 30) // Firestore limits the 'in' clause to 30 items

    const queries = chunks.map((idsChunk) =>
      FirestoreService.filterItems(COLLECTIONS.HORSE_COMPETITION_PAPERWORK.NAME, [
        where(COLLECTIONS.HORSE_COMPETITION_PAPERWORK.FIELDS.HORSE_ID.KEY, 'in', idsChunk),
      ])
    )

    const snapshotsArray = await Promise.all(queries)

    snapshotsArray.forEach((snapshots) => {
      snapshots.forEach((doc) => {
        const current = getConvertedData(
          HorseCompetitonPaperworkModel.fromFirestoreDoc(doc).toObject()
        )
        horsesCompetitionPaperwork.push(current)
      })
    })
  }

  return horsesCompetitionPaperwork
}

const HorseCompetitionPaperworkService = {
  getById,
  getByHorseIds,
}
export default HorseCompetitionPaperworkService
